import SwitchWithLabels from './SwitchWithLabels.js';
export default SwitchWithLabels